import React, { useEffect, useState } from 'react';
import { fetchDefaultPrices, saveDefaultPrices } from './api';
import './DefaultPrices.css';

// Admin Settings › Default Prices: a price per wheel for each work order service. A work order
// made by someone without Sales Base is priced at number of wheels × its service's price.
const DefaultPrices = () => {
  const [prices, setPrices] = useState(null);
  const [saved, setSaved] = useState(null);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetchDefaultPrices()
      .then((data) => { setPrices(data); setSaved(data); })
      .catch((err) => setError(err.response?.data?.error || 'Could not load the default prices.'));
  }, []);

  const handleChange = (service, value) => {
    setPrices((prev) => ({ ...prev, [service]: value }));
    setMessage('');
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setMessage('');
    try {
      const data = await saveDefaultPrices(prices);
      setPrices(data);
      setSaved(data);
      setMessage('Default prices saved.');
    } catch (err) {
      const errors = err.response?.data?.errors;
      setError(errors
        ? Object.entries(errors).map(([service, problem]) => `${service}: ${problem}`).join(' ')
        : (err.response?.data?.error || 'Could not save the default prices.'));
    } finally {
      setSaving(false);
    }
  };

  if (!prices) {
    return <div className="default-prices">{error ? <p className="default-prices-error">{error}</p> : 'Loading…'}</div>;
  }

  const changed = Object.keys(prices).some((service) => String(prices[service]) !== String(saved[service]));

  return (
    <div className="default-prices">
      <h4>Default Prices</h4>
      <p className="default-prices-help">
        Price per wheel for each work order service. When someone without Sales Base makes a work order,
        its price is the number of wheels × the service's price here. Blank or 0 means no price.
      </p>
      <div className="default-prices-list">
        {Object.keys(prices).map((service) => (
          <label key={service} className="default-prices-row">
            <span className="default-prices-service">{service}</span>
            <span className="default-prices-amount">
              $
              <input
                type="number"
                min="0"
                step="0.01"
                value={prices[service]}
                onChange={(e) => handleChange(service, e.target.value)}
              />
              <span className="default-prices-unit">per wheel</span>
            </span>
          </label>
        ))}
      </div>
      {error && <p className="default-prices-error">{error}</p>}
      {message && <p className="default-prices-message">{message}</p>}
      <button type="button" className="save-btn" onClick={handleSave} disabled={saving || !changed}>
        {saving ? 'Saving…' : 'Save Default Prices'}
      </button>
    </div>
  );
};

export default DefaultPrices;
